import { Roles } from "../../mp-utils/generic-utils"
import { ChipColor } from "../../mp-shared-components/generic-shared-components/components/Chip"

export const ROLE_CHIP_COLOR: Record<string, ChipColor> = {
  [Roles.District_Admin]: "info",
  [Roles.School_Admin]: "secondary",
  [Roles.Teacher]: "primary",
  [Roles.ACT_Admin]: "default",
  [Roles.ACT_Multi_District_Admin]: "warning"
}
